'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _checks = require('./checks.html');

var _checks2 = _interopRequireDefault(_checks);

var _checks3 = require('./checks.controller');

var _checks4 = _interopRequireDefault(_checks3);

require('./checks.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checksComponent = {
  restrict: 'E',
  bindings: {},
  template: _checks2.default,
  controller: _checks4.default,
  controllerAs: 'vm'
};

exports.default = checksComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/checks/checks.component.js
 **/